export default "/images/room.jpg?dac57f6e4994ecebd697d7476fddc042";